module.exports = __webpack_public_path__ + "static/media/charts-720p.6e311af3.webm";